import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';
import { BusinessGuideService } from '../../core/services/business-guide.service';

@Component({
  selector: 'app-business-guide-drawer',
  imports: [FormsModule, MatIconModule, A11yModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:keydown.escape)': 'onEscape($event)',
  },
  templateUrl: './business-guide-drawer.component.html',
  styleUrl: './business-guide-drawer.component.scss',
})
export class BusinessGuideDrawerComponent {
  public readonly guideService = inject(BusinessGuideService);

  readonly expandedFaqId = signal<string | null>(null);

  onEscape(event: Event): void {
    if (this.guideService.isOpen()) {
      event.preventDefault();
      this.guideService.closeGuide();
    }
  }

  toggleFaq(id: string): void {
    this.expandedFaqId.set(this.expandedFaqId() === id ? null : id);
  }

  isFaqExpanded(id: string): boolean {
    return this.expandedFaqId() === id;
  }

  selectModule(key: string): void {
    this.guideService.selectedModuleKey.set(key);
    this.guideService.activeTab.set('context');
  }

  setCategory(cat: string): void {
    this.guideService.selectedFaqCategory.set(cat);
  }
}
